import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import useWindowSize from "shared/customHooks/windowSize";
import styles from "./style.module.scss";
import { routeConstant } from "shared/routes/routesConstant";
import { useNavigate } from "react-router-dom";

function RecentTransactionGrid() {
  const navigate = useNavigate();
  const screenWidth = useWindowSize();

  const user_roles = {
    school: 1,
    teacher: 2,
    parent: 3,
    individual_reader: 4,
    author: 5,
    publisher: 6,
    family_kid: 7,
    student: 8,
  };

  const paymentStatus = {
    pending: 1,
    sent: 2,
    recieved: 3,
  };

  const payment_method = {
    online: 1,
    manual: 2,
    account_transfer: 3,
  };

  let partners = [
    {
      role: 1,
      name: "School Name",
      payment_method: 1,
      status: 1,
      amount: "38000",
      phone: "030000000000",
    },
    {
      role: 4,
      name: "Kid Name",
      payment_method: 3,
      status: 2,
      amount: "32000",
      phone: "030000000000",
    },
    {
      role: 3,
      name: "Parent Name",
      payment_method: 1,
      status: 3,
      amount: "29000",
    },
    {
      role: 4,
      name: "Author Name",
      payment_method: 2,
      status: 3,
      amount: "23000",
      phone: "030000000000",
      publishing_house: "Publication House",
    },
    {
      role: 5,
      name: "Publisher Name",
      payment_method: 1,
      status: 3,
      amount: "50000",
      phone: "030000000000",
      publication_house: "Publication House",
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainTableContainer}>
        <Box className={styles.topHeadingContainer}>
          <div>
            <div className={styles.heading}>
              Most Purchased Plans by Account List
            </div>
            <div className={styles.subHeading}>
              Most Plans purchased by parents, plans are list by most sales{" "}
            </div>
          </div>
          <div className={styles.btnContainer}>
            <button
              className={styles.viewAllBtn}
              onClick={() => navigate(routeConstant.allplanstransactions.path)}
            >
              View All
            </button>
            <button className={styles.filterBtn}>
              <Icons.FilterIcon /> Filter
            </button>
          </div>
        </Box>

        <TableContainer
          component={Paper}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
          className={styles.tableContainer}
          id="table-view-dashboard"
        >
          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Phone No</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Payment Method</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {partners?.map((item: any, index: number, arr: any[]) => {
                return (
                  <TableRow
                    className={classNames(
                      index + 1 === arr?.length && styles.noBorder
                    )}
                  >
                    <TableCell className={styles.biggerCell}>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={Images.UserPlaceholderImage}
                          alt="profile_picture"
                          className={styles.profilepic}
                        />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>{item?.name}</label>
                          {item?.publication_house ? (
                            <label className={styles.publishingHouse}>
                              Publishing House
                            </label>
                          ) : null}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      {item?.role === user_roles.parent
                        ? "Parent"
                        : item?.role === user_roles.individual_reader
                        ? "Individual Kid"
                        : item?.role === user_roles.author
                        ? "Author"
                        : item?.role === user_roles.publisher
                        ? "Publisher"
                        : item?.role === user_roles.school
                        ? "School"
                        : "---"}
                    </TableCell>
                    <TableCell>{item?.phone ? item?.phone : "----"}</TableCell>
                    <TableCell>
                      Rs.{" "}
                      {item?.amount
                        ? Number(item?.amount).toLocaleString()
                        : "----"}
                    </TableCell>
                    <TableCell>
                      {item?.payment_method === payment_method.manual
                        ? "Manual"
                        : item?.payment_method === payment_method.online
                        ? "Online"
                        : item?.payment_method ===
                          payment_method.account_transfer
                        ? "Account Transfer"
                        : ""}
                    </TableCell>

                    <TableCell className={classNames(styles.statusCell)}>
                      <label
                        className={
                          item?.status === paymentStatus.pending
                            ? styles.pending
                            : item?.status === paymentStatus.sent
                            ? styles.neutral
                            : item?.status === paymentStatus.recieved
                            ? styles.approved
                            : ""
                        }
                      >
                        {item?.status === paymentStatus.pending
                          ? "Pending"
                          : item?.status === paymentStatus.recieved
                          ? "Recieved"
                          : item?.status === paymentStatus.sent
                          ? "Sent"
                          : "----"}
                      </label>
                    </TableCell>
                    <TableCell>
                      <div className={styles.actionContainer}>
                        <Tooltip arrow title="View">
                          <div>
                            <Icons.EyeIcon2 />
                          </div>
                        </Tooltip>
                        {item?.status === paymentStatus.pending ? (
                          <>
                            <Tooltip arrow title="Approve">
                              <div>
                                <Icons.ApproveIcon />
                              </div>
                            </Tooltip>
                            <Tooltip arrow title="Reject">
                              <div>
                                <Icons.RejectIcon />
                              </div>
                            </Tooltip>
                            <Tooltip arrow title="Stop">
                              <div>
                                <Icons.StopCircleIcon />
                              </div>
                            </Tooltip>
                          </>
                        ) : null}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default RecentTransactionGrid;
